import React from 'react';
import { HomeContainer } from '@/modules/Home';

const SignIn = (): JSX.Element => <HomeContainer />;

export default SignIn;
